<form *ngIf="formGroup" [formGroup]="formGroup" formFocusable>
  <app-feedback-card [originalModel]="originalModel" [formGroup]="formGroup"></app-feedback-card>

  <app-default-card
    [title]="'Interne Informationen'"
    *ngIf="authorizationService.hasRole('ROLE_EDITOR_BASE')"
    [info]="''">
    <app-internal-information [inputForm]="formGroup"></app-internal-information>
  </app-default-card>

  <app-default-card
    [title]="'Anlagenstandort'"
    [info]="'Anschrift der Anlage'"
    [errorMessage]="'Anschlussadresse ist erforderlich'">
    <app-connection-object
      [areaType]="AreaTypeEnum.POWER"
      [disable]="disableAll$ | async"
      [inputForm]="formGroup"></app-connection-object>
  </app-default-card>

  <app-default-card
    [title]="'Anschlussnehmer (Eigentümer)'"
    [info]="
      'Name und Anschrift der natürlichen oder juristischen Person (z. B. Eigentümer), dessen Kundenanlage unmittelbar über einen Anschluss mit dem Netz des Netzbetreibers verbunden ist.'
    ">
    <!-- Hier soll eine Checkbox rein wenn der Status initial ist mit "Abweichender Anschlussnehmer" -->
    <!-- Wenn die Checkbox angehakt ist soll das flanged Form angezeigt werden, sonst nicht.  -->

    <app-contact-form
      [formGroup]="customer"
      [connectionObjectData]="connectionObjectData$ | async"
      [differsFromCurrentUser]="
        'gridRegistration.customerMailNotInstallerMail' | uiAdaptionVisible : true
      "></app-contact-form>
  </app-default-card>

  <app-default-card
    [title]="'Anschlussnutzer (Anlagenbetreiber)'"
    [info]="
      'Name und Anschrift der natürlichen oder juristischen Person, die im Rahmen eines Anschlussnutzungsverhältnisses einen Anschluss an das Niederspannungsnetz zur allgemeinen Versorgung zur Entnahme oder Einspeisung von elektrischer Energie nutzt.'
    ">
    <form-row>
      <mat-checkbox
        formControlName="differingInvoiceContact"
        (change)="resetDifferingInvoiceContactForm($event.checked)">
        Ist der Anschlussnutzer abweichend vom Anschlussnehmer?
      </mat-checkbox>
    </form-row>
    <app-contact-form
      *ngIf="differingInvoiceContact"
      [formGroup]="invoiceContact"
      [connectionObjectData]="connectionObjectData$ | async"
      [differsFromCurrentUser]="
        'gridRegistration.customerMailNotInstallerMail' | uiAdaptionVisible : true
      "></app-contact-form>
  </app-default-card>

  <app-default-card [title]="'Art der Erzeugungsanlage'" [info]="''">
    <app-grid-registration-type-v2
      [inputForm]="formGroup"
      [storageForm]="storageFormGroup"></app-grid-registration-type-v2>
  </app-default-card>

  <app-default-card [title]="'Informationen zur Anschlussleistung'" [info]="''">
    <form-row>
      <mat-form-field fxFlex appearance="outline">
        <mat-label>Installierte Modulleistung (kWp)</mat-label>
        <input matInput type="number" min="0" formControlName="newInstalledPower" />
        <mat-hint>Wie hoch ist die gesamte Leistung aller verbauten PV-Module?</mat-hint>
        <mat-error>Die installierte Modulleistung ist ein Pflichtfeld!</mat-error>
      </mat-form-field>
    </form-row>

    <form-row>
      <mat-form-field fxFlex appearance="outline">
        <mat-label>Maximale Scheinleistung (kVA)</mat-label>
        <input matInput type="number" min="0" formControlName="newProduction" />
        <mat-hint>Gesamtscheinleistung aller Wechselrichter</mat-hint>
        <mat-error>Die maximale Scheinleistung ist ein Pflichtfeld!</mat-error>
      </mat-form-field>
    </form-row>
  </app-default-card>

  <app-default-card
    *ngIf="showFeedInCompensationTypeQuestion"
    [title]="'Informationen zur Vergütung*'"
    [info]="'Bitte geben Sie uns hier an, welche Art der Vergütung für die Anlage vorgesehen ist.'">
    <!-- Neue Felder für die Abfrage der Vergütungsform -->
    <ng-container>
      <form-row>
        <mat-radio-group
          aria-label="feedInCompensationType"
          class="radio-group"
          formControlName="feedInCompensationType">
          <section>
            <mat-radio-button
              class="radio-button"
              [value]="'EEG_COMPENSATION'"
              *ngIf="newInstalledPower < 100">
              <h4>Einspeisevergütung nach § 21 Abs. 1 Nr. 1, 3, 4 EEG</h4>
              Ich (der Anlagenbetreiber) wünsche für den eingespeisten Strom
              <strong>eine Einspeisevergütung</strong>
              und nehme § 21 Abs. 1 Nr. 1, 3, 4 EEG in Anspruch.
              <br />
              <ng-container *ngIf="'gr_eegCompensationCustomHint' | uiAdaptionVisible; else noAdaption">
                <span>{{ 'gr_eegCompensationCustomHint' | uiAdaptionValue }}</span>
              </ng-container>
              <ng-template #noAdaption>
                <span>
                  In diesem Fall werden wir, nach Abschluss der technischen Prozesse, auf den Anlagenbetreiber
                  zukommen, um die notwendigen Informationen abzufragen.
                </span>
              </ng-template>
            </mat-radio-button>
          </section>

          <section>
            <mat-radio-button
              class="radio-button"
              [value]="'NO_COMPENSATION'"
              *ngIf="newInstalledPower < 400">
              <h4>Unentgeltliche Abnahme nach § 21 Abs. 1 Nr. 2 EEG</h4>
              <p>
                Ich wünsche für den eingespeisten Strom keine Einspeisevergütung und nehme die
                <strong>unentgeltliche Abnahme</strong>
                nach § 21 Abs. 1 Nr. 2 EEG in Anspruch.
              </p>
            </mat-radio-button>
          </section>

          <section>
            <mat-radio-button
              class="radio-button"
              [value]="'SUBST_DIRECT_MARKETING'"
              *ngIf="newInstalledPower < 1000">
              <h4>Geförderte Direktvermarktung (Marktprämie) nach § 20 EEG</h4>
              <p>Die Anlage wird in die geförderte Direktvermarktung gehen.</p>
            </mat-radio-button>
          </section>

          <section>
            <mat-radio-button
              class="radio-button"
              [value]="'TENANT_ELECTRICITY_SURCHARGE'"
              *ngIf="newInstalledPower < 1000">
              <h4>Mieterstromzuschlag nach § 21 Abs. 3 EEG</h4>
              <p></p>
            </mat-radio-button>
          </section>

          <section>
            <mat-radio-button class="radio-button" [value]="'MISC_DIRECT_MARKETING'">
              <h4>Sonstige Direktvermarktung nach § 21a EEG</h4>
              <p>Die Anlage wird in die sonstige Direktvermarktung gehen.</p>
            </mat-radio-button>
          </section>
        </mat-radio-group>
      </form-row>

      <ng-container *ngIf="directMarketing">
        <form-row>
          <div class="alert alert-info">
            Sie erhalten nach erfolgreicher Anmeldung von uns eine MaLo / MeLo die Sie Ihrem Direktvermarkter
            mitteilen müssen.
          </div>
        </form-row>

        <!-- Neue Felder für die Abfrage des Direktvermarkters -->
        <form-row>
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Direktvermarkter</mat-label>
            <input matInput type="text" formControlName="directMarketer" fxFlex />
            <mat-hint>
              Sollten Sie bereits Ihren Direktvermarkter kennen, können Sie ihn uns hier mitteilen.
            </mat-hint>
          </mat-form-field>
        </form-row>
      </ng-container>
    </ng-container>
  </app-default-card>

  <app-default-card *ngIf="selectedCompanyLocation$ | async" [title]="'Einspeisermanagement'" [info]="''">
    <app-grid-registration-feedin-management-info-v2
      [selectedCompanyLocation$]="selectedCompanyLocation$"
      [inputForm]="formGroup"
      [feedInCompensationType$]="feedInCompensationType$"
      [totalPowerProducers$]="totalPowerEEG$"></app-grid-registration-feedin-management-info-v2>
  </app-default-card>

  <app-default-card *ngIf="!!storageFormGroup" [title]="'Speicher'" [info]="''">
    <app-grid-registration-storage-v2
      [canUpdate$]="canUpdate$"
      [disable$]="disableAll$"
      [formGroup]="storageFormGroup"></app-grid-registration-storage-v2>

    <div *ngIf="firstConsumer" [formGroup]="firstConsumer">
      <h2>Angaben zum Speicher als Verbraucher</h2>

      <!-- Allgemeine Info's zum Verbraucher selber. -->
      <form-row>
        <mat-form-field fxFlex="50" appearance="outline">
          <mat-label>Leistung (kW)</mat-label>
          <input matInput type="number" min="0" formControlName="power" />
          <mat-hint>Leistung (kW) pro Speicher</mat-hint>
        </mat-form-field>
      </form-row>

      <p style="margin-top: 1rem">
        <strong>
          Gesamtwechselrichterleistung der Speicher:
          {{ totalConsumerStoragePower$ | async | number : undefined : 'de-DE' }} kW
        </strong>
      </p>

      <!-- Felder für Speicher -->
      <app-grid-registration-storage-fields-v2
        [inputForm]="firstConsumer"></app-grid-registration-storage-fields-v2>

      <app-grid-registration-p14-formpart
        [inputForm]="firstConsumer"
        [consumerType]="GridRegistrationTypeEnum.Storage" />
    </div>
  </app-default-card>

  <app-default-card
    *ngIf="isAreaTypeAvailableInObjectAddress && !(hideAdditionalGridConnectionPointInformationCard$ | async)"
    [title]="'Weitere Informationen zum Netzanschluss'"
    [info]="'Hier können Sie uns noch weitere wichtigen Informationen zu Ihrem Netzanschluss mitteilen'"
    [showThisComponent]="true"
    [showChildComponent]="true">
    <app-grid-registration-more-info
      [inputForm]="formGroup"
      [gridRegistrationType]="gridRegistrationType"
      [disabledAllFields]="disableAll$ | async"
      [inputFormFreeMoreInformation]="formGroup"></app-grid-registration-more-info>
  </app-default-card>

  <app-default-card [title]="'Dokumente'" [info]="''">
    <app-upload-documents
      [inputFormArray]="uploads"
      [documentTag]="'uploads'"
      [showTag]="false"
      [canUpdate]="true"
      [filterCriteria]="'equal'"
      [numberOfUploads]="10"
      [editUpload]="true"
      [showUploadButton]="true">
      <div>
        <ng-container
          *ngIf="documentsUploadInfoUIAdaptionName | uiAdaptionVisible; else defaultTechnicalDocumentsInfo">
          <div [innerHTML]="documentsUploadInfoUIAdaptionName | uiAdaptionValue | safeHtmlPipe"></div>
        </ng-container>
        <ng-template #defaultTechnicalDocumentsInfo>
          <p>
            Relevante technische Dokumentationen.
            <br />
            z.B. Datenblätter der verbauten Komponenten, Zertifikate und einen einpoligen
            Übersichtsschaltplan.
            <br />
          </p>
        </ng-template>
      </div>
    </app-upload-documents>
  </app-default-card>

  <app-default-card [title]="'Optionale Informationen'" [type_class]="'notice--left'">
    Die folgenden Informationen sind nicht als Pflicht zu befüllen und können vom Installateur später noch
    beim Inbetriebsetzen nachgereicht werden.
  </app-default-card>

  <app-default-card
    [title]="'Messkonzept'"
    [info]="'Bitte wählen Sie hier das von Ihnen geplante Messkonzept aus.'"
    [error]="errorFormList.length > 0 && !formGroup.get('meteringConcept')">
    <app-grid-registration-metering-concept-v2
      [disable]="!(canUpdate$ | async)"
      [control]="meteringConcept"></app-grid-registration-metering-concept-v2>
  </app-default-card>

  <!-- WENN PV => DANN (WECHSELRICHTER) -->

  <app-default-card
    [title]="'Erzeugungseinheiten'"
    [info]="
      'Sie haben hier die Möglichkeit bereits Ihre geplanten Komponenten zu hinterlegen. ' +
      'Bei PV-Anlagen ist hier der Wechselrichter gemeint.'
    "
    [error]="formGroup.errors?.thresholdExceeded"
    [errorMessage]="
      'Die Summe der installierten Leistung übersteigt die von Ihnen angemeldete. Bitte prüfen Sie die oben beantragte Leistung'
    ">
    <app-grid-registration-producer-v2
      [inputFormArray]="producers"
      [gridRegistration]="this.originalModel"
      [disable]="!(canUpdate$ | async)"></app-grid-registration-producer-v2>
  </app-default-card>

  <app-default-card
    [title]="'PV-Module'"
    [info]="'Sie haben hier die Möglichkeit bereits Ihre geplanten Komponenten zu hinterlegen.'"
    [errorMessage]="
      'Die Summe der installierten Leistung übersteigt die von Ihnen angemeldete. Bitte prüfen Sie die oben beantragte Leistung'
    "
    [error]="formGroup.errors?.thresholdExceeded">
    <app-grid-registration-pv-module-v2
      [requireOne]="false"
      [disable]="!(canUpdate$ | async)"
      [inputFormArray]="pvModules"></app-grid-registration-pv-module-v2>
  </app-default-card>

  <app-default-card [title]="'Bedingungen'" [info]="''">
    <app-accept-conditions
      [inputForm]="formGroup"
      [controlName]="'acceptedConditions1'"
      [inputLink]=""
      [inputText]="'Hiermit bestätige ich, dass die Zustimmung des Eigentümers vorliegt.'">
      <!-- Todo: quick and dirty Lösung.
            Wenn mehr Bedarf an weiteren Conditions besteht, dann die Unterkomponente ausbauen, bzw acceptedConditions zu FormArray umbauen?-->
      <form-row
        *ngIf="
          (powerThresholdReached$ | async) && 'gridRegistration.powerThresholdConditions_30'
            | uiAdaptionValue as conditions
        ">
        <mat-checkbox formControlName="acceptedConditions2">
          <div [innerHTML]="conditions | safeHtmlPipe"></div>
        </mat-checkbox>
      </form-row>
      <mat-error
        *ngIf="
          (powerThresholdReached$ | async) &&
          !formGroup.get('acceptedConditions2').valid &&
          formGroup.get('acceptedConditions2').touched
        ">
        Bitte akzeptieren Sie alle Bedingungen
      </mat-error>
    </app-accept-conditions>
  </app-default-card>
</form>
